export class SaveEngagement{
  id: string;
  engagementId :string;
  agentName : string;
  customerName : string;
  customerPhone :string;
  customerAddress : string;
  startTime : string;
  endTime : string;
  duration : string;
  queueName : string;
  channelName : string;
  direction : string;
  url: string;
  ticketId :string[];
}

export class GetEngagement {
    currentpageno: number = 1;
    pageitem: number = 10;
    orderType: string = "desc";
    type: string = "string";
    field: string = "agentName";
    operator: string = "contains";
    value: string = "";
    orderColumn: string = "startTime";
    clientId: string | null;
    consultantId: string | null;
    startDate: string | null;
    endDate: string | null;
    matchCase: boolean = false;
    agencyID: string | null;
    locationID: string | null;
    channelName : string|null;
    queueName : string|null;
    direction :string|null;
    engagementIds:string[] =[];
    customerId : string;
    customerType : string;

}
export class Tickets{
     id :string="00000000-0000-0000-0000-000000000000"
     uniqueTicketId :string ;
     title : string ;
     summary :string;
     statusLid :string;
     statusLovCode :string ;
     ticketTypeLid :string ;
     ticketTypeLovCode :string ;
     priorityLid :string ;
     priorityLovCode :string;
     employeeId :string;
     employeeName:string ;
     engagementLogsId: string;
     clientId : string;
     
}

export class LinkTickets{
  ticketIds : string[];
  engagementLogId : string;
}